import type { CardDetail, CardStockUpdate } from "@hobbyshopify/backend-client";
import { Rx } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../core/primitives/load-status";
import type { CardPrices } from "../cards/cards-model";

/** The card dialogs; price history is its own section. */
export type CardDetailDialog = "price" | "stock" | "archive";

export class CardDetailState {
  readonly detail = new Rx<CardDetail | null>(null);
  readonly status = new Rx<LoadStatus>(idleLoad);
  /** A request is in flight for this card. */
  readonly busy = new Rx(false);
  readonly notice = new Rx<string | null>(null);
  readonly dialog = new Rx<CardDetailDialog | null>(null);
  /** What the open dialog reports in place. */
  readonly dialogError = new Rx<string | null>(null);
  /** Whether the caller may reprice, archive or set price/floor/stock. `true` until the role is known. */
  readonly canEditInventory = new Rx(true);
}

export abstract class CardDetailActions {
  abstract reprice(): Promise<void>;
  abstract retry(): void;
  abstract openDialog(dialog: CardDetailDialog): void;
  abstract closeDialog(): void;
  abstract savePrices(next: CardPrices): Promise<void>;
  abstract saveStock(change: CardStockUpdate): Promise<void>;
  abstract confirmArchive(): Promise<void>;
}
